import $ from 'jquery';

$(function () {
    $('.modal').on('open.zf.reveal', function () {
        let $this = $(this);
        let $orbit = $(this).find('.orbit');

        new Foundation.Orbit($orbit);
    });
});